import React from 'react';
import ReactDOM from 'react-dom';

if (!React) {
    throw new Error('"rio-accountmenu" needs a global React on the page');
}

if (!ReactDOM) {
    throw new Error('"rio-accountmenu" needs a global ReactDOM on the page');
}

import DefaultAccountMenu from './components/DefaultAccountMenu';

import {
    EVENT_USER_LANGUAGE_CHANGED,
    EVENT_USER_LOGGED_OUT,
    EVENT_USER_PROFILE_CHANGED,
} from './constants/api';

export { // eslint-disable-line no-undef
    DefaultAccountMenu,
    EVENT_USER_LANGUAGE_CHANGED,
    EVENT_USER_LOGGED_OUT,
    EVENT_USER_PROFILE_CHANGED,
};
